import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'fragebogenTyp'
})
export class FragebogenTypPipe implements PipeTransform {

  constructor(
    private readonly translateService: TranslateService) {
  }

  transform(appName: string): string {
    switch (appName) {
      case 'Fragebogen_EUn':
        return this.translateService.instant('FRAGEBOEGEN_APP.FRAGEBOEGEN_TYP.EUN');
      case 'Fragebogen_KapG':
        return this.translateService.instant('FRAGEBOEGEN_APP.FRAGEBOEGEN_TYP.KAP_GES');
      case 'Fragebogen_PersG':
        return this.translateService.instant('FRAGEBOEGEN_APP.FRAGEBOEGEN_TYP.PERS_GES');
      case 'Fragebogen_BetPG':
        return this.translateService.instant('FRAGEBOEGEN_APP.FRAGEBOEGEN_TYP.BETPG');
      case 'Fragebogen_KapGAus':
        return this.translateService.instant('FRAGEBOEGEN_APP.FRAGEBOEGEN_TYP.KAPG_AUS');
      default:
        return 'Fragebogentyp nicht bekannt';
    }
  }

}
